module.exports = __webpack_public_path__ + "img/background037.jpg";